export interface SalaryDefaults {
  min: number;
  max: number;
}

export const salaryDefaults: SalaryDefaults = {
  min: 1000,
  max: 30000,
};
